import gql from 'graphql-tag';

export default gql`
mutation UPDATE_IS_READ_TAB_NOTIFICATION(
  $inAppNotificationKsuid: String!
  $companyKsuid: String!
) {
  readInAppNotification(
    inAppNotificationKsuid: $inAppNotificationKsuid
    companyKsuid: $companyKsuid
  ) {
    ksuid
  }
}

`;
